import React, { useState } from "react";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import { FormLabel, GridLegacy, Typography } from "@mui/material";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper.tsx";

import { talenV5 } from "../../../variables/app";
import FormTextTC from "../../../components/Forms/FormTextTC";
import { useController } from "react-hook-form";
import { useApplicationDefaultLanguage, useSelectedBackofficeLanguages } from "../../../../utils/languageHooks";

function Translations(props) {
  const [translationsInit, setTranslationsInit] = useState({});

  const defaultLanguage = useApplicationDefaultLanguage();
  const backofficeLanguages = useSelectedBackofficeLanguages(defaultLanguage);

  const {
    field: { value: translationsValue, onChange: translationsOnChange },
  } = useController({ name: "translations" });

  if (Object.keys(translationsInit ?? {}).length === 0 && translationsValue != null) {
    setTranslationsInit(translationsValue);
  }

  return (
    <div style={{ width: "100%", height: "100%", overflow: "hidden" }}>
      <GridLegacy container spacing={1}>
        <GridLegacy item lg={6} xs={12}>
          <Card>
            <CardBody style={{ padding: 16 }}>
              <GridLegacy container spacing={1}>
                <GridLegacy item xs={12}>
                  <Typography component={"h3"}>
                    <TranslationWrapper tDefault={"Vertaling naam"} tKey={"producten.form.tabs.vertalingNaam"} />
                  </Typography>
                </GridLegacy>
                {backofficeLanguages.map((objKey) => {
                  let taal = talenV5[objKey];

                  return (
                    <FormTextTC
                      key={objKey}
                      label={
                        <FormLabel>
                          <TranslationWrapper tDefault={"Naam in"} tKey={"producten.form.vertalingennaam.label.naam"} />{" "}
                          <TranslationWrapper tDefault={taal.label} tKey={"global." + taal.transKey} />
                        </FormLabel>
                      }
                      name={"translations." + objKey + ".naam"}
                    />
                  );
                })}
              </GridLegacy>
            </CardBody>
          </Card>
        </GridLegacy>
        <GridLegacy item lg={6} xs={12}>
          <Card>
            <CardBody style={{ padding: 16 }}>
              <GridLegacy container spacing={1}>
                <GridLegacy item xs={12}>
                  <Typography component={"h3"}>
                    <TranslationWrapper
                      tDefault={"Vertaling omschrijving"}
                      tKey={"producten.form.tabs.vertalingOmschrijving"}
                    />
                  </Typography>
                  {backofficeLanguages.map((objKey) => {
                    let taal = talenV5[objKey];

                    return (
                      <FormTextTC
                        key={objKey}
                        label={
                          <FormLabel>
                            <TranslationWrapper tDefault={taal.label} tKey={"global." + taal.transKey} />
                          </FormLabel>
                        }
                        name={"translations." + objKey + ".omschrijving"}
                      />
                    );
                  })}
                </GridLegacy>
              </GridLegacy>
            </CardBody>
          </Card>
        </GridLegacy>
      </GridLegacy>
    </div>
  );
}

export default Translations;
